module.exports = __webpack_public_path__ + "img/team-3-800x800.5a0e395b.jpg";